export default __webpack_public_path__ + "static/media/24-hours.6aed444f.svg";